export default "__VITE_ASSET__yWR1TW86__"